import { Injectable, inject, Injector, ApplicationRef } from '@angular/core';
import { Router } from '@angular/router';

import Crypto from './crypto';
import Auth from './auth';
import File from './file';
import Alert from './alert';
import Loading from './loading';
import Request from './request';
import Toast from './toast';
import Navbar from './navbar';
import Lang from './lang';
import Trigger from './trigger';

@Injectable({ providedIn: 'root' })
export class Service {
    public auth: Auth;
    public file: File;
    public alert: Alert;
    public loading: Loading;
    public request: Request;
    public toast: Toast;
    public navbar: Navbar;
    public lang: Lang;
    public trigger: Trigger;
    public crypto: Crypto;
    public app: any;

    private injector = inject(Injector);
    private _router: Router | null = null;
    private _appRef: ApplicationRef | null = null;

    private get router(): Router {
        if (!this._router) {
            this._router = this.injector.get(Router);
        }
        return this._router;
    }

    private get appRef(): ApplicationRef {
        if (!this._appRef) {
            this._appRef = this.injector.get(ApplicationRef);
        }
        return this._appRef;
    }

    public async init(app: any) {
        if (app) {
            this.app = app;
            if (!this.crypto) this.crypto = new Crypto();
            if (!this.auth) this.auth = new Auth(this);
            if (!this.file) this.file = new File(this);
            if (!this.alert) this.alert = new Alert(this);
            if (!this.loading) this.loading = new Loading(this);
            if (!this.navbar) this.navbar = new Navbar(this);
            if (!this.request) this.request = new Request();
            if (!this.toast) this.toast = new Toast();
            if (!this.trigger) this.trigger = new Trigger();

            if (this.app.translate) {
                if (!this.lang) this.lang = new Lang(this);
                let lang: string = (navigator.language || (navigator as any).userLanguage).substring(0, 2).toLowerCase();
                if (!['ko', 'en'].includes(lang)) lang = 'en';
                this.lang.set(lang);
            }

            await this.loading.show();
            await this.auth.init();
        }

        await this.auth.check();
        return this;
    }

    public async sleep(time: number = 0) {
        let timeout = () => new Promise((resolve) => {
            setTimeout(resolve, time);
        });
        await timeout();
    }

    public async render(time: number = 0) {
        let timeout = () => new Promise((resolve) => {
            setTimeout(resolve, time);
        });
        if (time > 0) {
            this.app?.ref?.detectChanges();
            await timeout();
        }
        this.app?.ref?.detectChanges();
        try { this.appRef.tick(); } catch (e) { }
    }

    public href(url: any) {
        this.router.navigateByUrl(url);
    }

    public random(stringLength: number = 16) {
        const fchars = 'abcdefghiklmnopqrstuvwxyz';
        const chars = '0123456789abcdefghiklmnopqrstuvwxyz';
        let randomstring = '';
        for (let i = 0; i < stringLength; i++) {
            let rnum = null;
            if (i === 0) {
                rnum = Math.floor(Math.random() * fchars.length);
                randomstring += fchars.substring(rnum, rnum + 1);
            } else {
                rnum = Math.floor(Math.random() * chars.length);
                randomstring += chars.substring(rnum, rnum + 1);
            }
        }
        return randomstring;
    }
}

export default Service;
